import api from '@/client/core/api'

import { InstagramInstantwinAnalyticsRow } from '../types'

export type GetInstagramInstantwinCampaignAnalyticsParams = {
  campaignId: number
  prizeId?: number | null
  startDatetime?: string
  endDatetime?: string
}

export type InstagramInstantwinCampaignAnalyticsApiResponse = {
  data?: InstagramInstantwinAnalyticsRow[]
  error?: {
    type?: string
    message?: string
    status?: number
  }
}

export class InstagramInstantwinCampaignAnalyticsApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
  }
}

export async function getInstagramInstantwinCampaignAnalytics(
  params: GetInstagramInstantwinCampaignAnalyticsParams
): Promise<InstagramInstantwinAnalyticsRow[]> {
  const requestParams: Record<string, unknown> = {}

  if (params.prizeId) {
    requestParams.prizeId = params.prizeId
  }
  if (params.startDatetime) {
    requestParams.startDatetime = params.startDatetime
  }
  if (params.endDatetime) {
    requestParams.endDatetime = params.endDatetime
  }

  const response = await api.get<InstagramInstantwinCampaignAnalyticsApiResponse>(
    `/instagram_instantwin_campaign_analytics/${params.campaignId}`,
    {
      params: requestParams
    }
  )

  if (response?.error?.type) {
    throw new InstagramInstantwinCampaignAnalyticsApiError(
      response.error.type,
      response.error.message,
      response.error.status
    )
  }

  return response.data ?? []
}
